import { NavigateFunction, useLocation, useNavigate, useOutletContext, useParams, useSearchParams } from "react-router-dom";

export interface RouterProps {
    location: any,
    context: any,
    params?: Record<string, any>,
    navigate: NavigateFunction
}
  
export interface Params {
    params: Record<string, any>
}
  
export function withRouter(Component: any) {
    function ComponentWithRouterProp(props: any) {
      let location = useLocation();
      let navigate = useNavigate();
      let params = useParams();
      let context = useOutletContext();
      const [searchParams, setSearchParams] = useSearchParams();
      return (
        <Component
          {...props}
          location={location}
          params={params}
          context={context}
          navigate={navigate}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />
      );
    }
  
    return ComponentWithRouterProp;
}